import React, { useState, useEffect } from "react";
import jMoment from "moment-jalaali";
import { Row, Col, Card } from "reactstrap";

import DatePicker from "../../components/Form/DatePicker";

import { getOfflineReportRequest } from "../../requests/analysisReports";

import { enDigits, faDigits, humanize } from "../../utils/formatDigits";


const OfflineReport = props => {
  const [reportsData, setReportsData] = useState();
  const [loading, setLoading] = useState();
  const [dates, setDates] = useState({
    startDate: jMoment().subtract(1, 'day').format('jYYYY-jM-jD'),
    endDate: jMoment().subtract(1, 'day').format('jYYYY-jM-jD')
  });
  useEffect(() => {
    if (!reportsData && !loading) {
      getReport(dates.startDate, dates.endDate);
    }
  })
  const getReport = (startDate, endDate) => {
    setDates({
      startDate: faDigits(startDate),
      endDate: faDigits(endDate)
    });
    setLoading(true);
    getOfflineReportRequest({
      startDate,
      endDate
    })
      .then(response => {
        setReportsData(response.data);
        setLoading(false);
      })
  }
  if (!reportsData) return null;
  return (
    <Card body className="mt-3 mb-3" inverse color="dark">
      <Row>
        <Col>
          تعداد آهنگ‌های آفلاین‌شده
          <h2 className="h1">
            <strong dir="ltr">{humanize(reportsData.count)}</strong>
          </h2>
        </Col>
        <Col>
          <Row>
            <Col>
              از
              <DatePicker
                input={{
                  onChange: value => getReport(enDigits(value), dates.endDate),
                  value: dates.startDate
                }}
              />
            </Col>
            <Col>
              تا
              <DatePicker
                input={{
                  onChange: value => getReport(dates.startDate, enDigits(value)),
                  value: dates.endDate
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  )
}

export default OfflineReport;